import React from "react";
import api from "@/lib/api";
import useFreshData from "@/lib/useFreshData";
import Hero from "@/components/home/Hero";
import Advantages from "@/components/home/Advantages";
import Board from "@/components/home/Board";
import Projects from "@/components/home/Projects";
import Events from "@/components/home/Events";
import WeeklyPlans from "@/components/home/WeeklyPlans";
import TarifaNews from "@/components/home/TarifaNews";
import FeaturedMembers from "@/components/home/FeaturedMembers";
import FAQ from "@/components/home/FAQ";
import FinalCTA from "@/components/home/FinalCTA";
import SEO, { organizationSchema, websiteSchema } from "@/components/seo/SEO";

const INITIAL = {
    news: [],
    board: [],
    projects: [],
    featured_members: [],
    events: [],
};

export default function Home() {
    const { data } = useFreshData(
        async () => {
            const r = await api.get("/site/summary");
            return r.data;
        },
        { initialData: INITIAL }
    );
    const view = data || INITIAL;

    return (
        <div data-testid="home-page">
            <SEO
                title="ASATTA · Asociación de Alojamientos Turísticos de Tarifa"
                description="ASATTA representa a los hoteles, hostales, campings y apartamentos turísticos de Tarifa. Únete a la asociación por 15 €/mes y forma parte del turismo de calidad del sur de Cádiz."
                path="/"
                jsonLd={[organizationSchema, websiteSchema]}
            />
            <Hero />
            <Advantages />
            <Board board={view.board} />
            <Projects projects={view.projects} />
            <Events events={view.events} />
            <WeeklyPlans />
            <TarifaNews />
            <FeaturedMembers members={view.featured_members} />
            <FAQ />
            <FinalCTA />
        </div>
    );
}
